import { useState } from 'react'
import TabBar from '@/components/shared/TabBar'
import RediviaNegocios from '@/components/redivia/RediviaNegocios'
import RediviaCobros from '@/components/redivia/RediviaCobros'
import { PageHeader } from '@/components/ui'
import { IconBuilding, IconReceipt } from '@/components/icons/Icons'

/* Redivia es una plataforma SaaS propia que le vende membresías mensuales a
   negocios. Acá vive su cobranza: el ERP decide qué compró el cliente, Redivia
   decide qué funciona.

   Dos pestañas porque son dos trabajos distintos: «Cobros» es lo operativo del
   mes (qué falta emitir, qué falta cobrar) y aterriza primero; «Negocios» es el
   registro de quién tiene qué plan. */
const TABS = [
  { key: 'cobros', label: 'Cobros', icon: <IconReceipt size={15} /> },
  { key: 'negocios', label: 'Negocios', icon: <IconBuilding size={15} /> },
]

const CRUMBS = [{ label: 'Operaciones' }, { label: 'Redivia' }]

export default function Redivia() {
  const [tab, setTab] = useState('cobros')

  return (
    <div className="page-enter page-shell" id="redivia">
      <PageHeader breadcrumbs={CRUMBS} />
      <TabBar tabs={TABS} activeTab={tab} onTabChange={setTab} />
      {tab === 'negocios' ? <RediviaNegocios /> : <RediviaCobros />}
    </div>
  )
}
